var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-content"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"my-auto w-100 main-area"},[_c('PrintProfile')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }